import React from 'react';
import Chip from '@mui/joy/Chip';
import CustomIcon from '../../components/customIcon/CustomIcon';
import Stack from "@mui/joy/Stack";
import Typography from '@mui/joy/Typography';
import Tooltip from "@mui/joy/Tooltip";
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalCellularConnectedNoInternet0BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet0Bar';
import SignalCellularOffIcon from '@mui/icons-material/SignalCellularOff';
import { formatDateTime } from "../../common/dateTime";

type DefaultProps = {
    connectionFailures: number,
    failedAt?: Date,
    failureReason?: string,
    resetFailureAt?: Date,
}

export function ProxyStatusIcon(props: DefaultProps) {
    const {connectionFailures, failedAt, failureReason, resetFailureAt} = props;
    const resetFailureDate = resetFailureAt ? new Date(resetFailureAt) : new Date();
    const icon = failedAt && (!resetFailureAt || resetFailureDate > new Date())
        ? SignalCellularOffIcon
        : connectionFailures > 0
            ? SignalCellularConnectedNoInternet0BarIcon
            : SignalCellularAltIcon;

    const color = failedAt && (!resetFailureAt || resetFailureDate > new Date())
        ? 'danger'
        : connectionFailures > 0
            ? 'warning'
            : 'success';

    return (
        <React.Fragment>
            <Stack spacing={.5} direction={'column'}>
                <Tooltip title={failureReason}>
                    <Chip
                        variant="soft"
                        size="sm"
                        startDecorator={<CustomIcon IconComponent={icon}/>}
                        color={color}
                    >
                        {`(ошибки - ${connectionFailures})`}
                    </Chip>
                </Tooltip>
                {resetFailureAt
                    ? <Typography level="body-xs">{`Сброс - ${formatDateTime(resetFailureAt)}`}</Typography>
                    : <></>}
            </Stack>
        </React.Fragment>
    );
}